import logo from './logo.svg';
import './App.css';
import CustomRouter from './component/CustomRouter';

function App() {
  return (
    <div className="App">
      <CustomRouter />
    </div>
  );
}

export default App;
